import { useState, useRef, useEffect } from "react"
import _ from "lodash"
import ScrollContainer from "react-indiana-drag-scroll";
import Link from "next/link";
import { pageLink } from '@/config/site';
import { TyreImage } from "../common/image";
import { _modelName } from "../../libraries/common";
import { SkeletonBrandItem, SkeletonParagraph, SkeletonTyreBrandItem } from "../common/skeleton";
import { EmptyData } from "../common/emptyData";
import { useRouter } from "next/router";
import { Skeleton } from "@mantine/core";
import { ExpendMore, IconStar } from "../common/icon";
import { colorBlueActiveCode, colorRedActiveCode } from "../../config/site";
import { CustomLink } from "../app/customLink";

export const TyreBrandList = (props) => {
    const { data = [], showSideBar = false, handleIndexItemClick = () => {}, handleClickBrandItem = () => {}, activeList = [], loading = false, t } = props
    const [modalWidthSize, setModalWidthSize] = useState(null)
    const modalVehicleBrandsWidthRef = useRef(null)
    const contactSections = useRef({});

    useEffect(()=>{
        if(showSideBar == true && modalWidthSize == null && modalVehicleBrandsWidthRef?.current?.offsetWidth > 0){
            setModalWidthSize(modalVehicleBrandsWidthRef?.current?.offsetWidth)
        }
    },[])

    if(loading == true){
        return (
            <div className='vehiclePage_vehicle_brandlistMargin'>
                <div className="vehicle_brandlistContainer">
                    <div className={"vehicle_brandlist"}>
                        {
                            _.times(3, (key)=>(
                                <div key={key}>
                                    <div className='vehicle_brandlist_titlebox containerPadding'>
                                        <div style={{width: '15rem'}}>
                                            <SkeletonParagraph row={1} isTitle={true} />
                                        </div>
                                    </div>
                                    {
                                        _.times(3, (key2)=>(
                                            <div key={key2} className='containerPadding'>
                                                <div className='vehicle_brandlist_rowBox'>
                                                    <Skeleton height={'4rem'} width={'7rem'} />
                                                    <div style={{width: '20rem', maxWidth: '100%'}}>
                                                        <SkeletonParagraph row={1}/>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        )
    }

    if(_.isEmpty(data)){
        return (
            <EmptyData t={t} />
        )
    }

    let organizedData = _.chain(data)
    .groupBy(brand => brand.name.charAt(0).toUpperCase())
    .toPairs()
    .orderBy(['0'], ['asc'])
    .map(pair => ({
        key: pair[0],
        values: _.orderBy(pair[1], ['name'], ['asc']) 
    }))
    .value()

    
    return (
        <div className="vehicle_brandlistContainer">
            {
                (showSideBar && modalWidthSize > 0) &&
                <div className="vehicle_brandlist_sideBarOuter" style={{right: `calc(50% - ${modalWidthSize/2}px)`}}>
                    <div className="vehicle_brandlist_sideBarVisible vehicle_brandlist_sideBarVisibleTop" />
                    <div className="vehicle_brandlist_sideBarVisible vehicle_brandlist_sideBarVisibleBottom" />
                    <div className="vehicle_brandlist_sideBar">
                        {
                            !_.isEmpty(organizedData) &&
                            _.reduce(organizedData, (result, value, key)=>{
                                result.push(
                                    <div onClick={()=>handleIndexItemClick(value.key, contactSections)} key={key} className="vehicle_brandlist_sideBarItem cursorPointer">
                                        <p className="fontSize_14 fontWeight_medium fontColor_red" style={{textAlign: 'center', lineHeight: 'normal'}}>
                                            {value.key}
                                        </p>
                                    </div>
                                )
                                return result
                            },[])
                        }
                    </div>
                </div>
            }
            
            <div ref={modalVehicleBrandsWidthRef} className={showSideBar == true ? 'vehicle_brandlist vehicle_brandlist_ifGotSideBar' : "vehicle_brandlist"}>
                {
                    _.reduce(organizedData, (result, value)=>{
                        result.push(
                            <div ref={(ref) => (contactSections.current[value.key] = ref)} key={value.key}>
                                <div className='vehicle_brandlist_titlebox containerPadding'>
                                    <p className='fontSize_16 fontWeight_medium'>
                                        {value.key}
                                    </p>
                                </div>
                                {
                                    _.reduce(value.values, (result2, value2, key2)=>{
                                        result2.push(
                                            <div onClick={()=>{handleClickBrandItem(value2)}} key={key2} className='containerPadding cursorPointer'>
                                                <div className='vehicle_brandlist_rowBox'>
                                                    <div className='vehicle_brandlist_iconOutner' style={{ width: '7rem' }}>
                                                        <div className='vehicle_brandlist_icon' style={{backgroundImage: `url(${process.env.NEXT_PUBLIC_FS_URL + value2?.image_path})`}} />
                                                    </div>
                                                    <p className={`fontSize_14 ${!_.isEmpty(activeList) ? _.includes(activeList, value2.brand_custom_url) ? 'fontColor_red' : undefined : undefined}`}>
                                                        {value2.name}
                                                    </p>
                                                </div>
                                            </div>
                                        )
                                        return result2
                                    },[])
                                }
                            </div>
                        )
                        return result
                    },[])
                }
            </div>
        </div>
    )
}

export const PopularTyreBrands = (props) => {
    const { data = [], isSingleRow = false, t, willForceRefresh = false, loading = false, isTyreDetail = false } = props
    const router = useRouter()

    if(isSingleRow == true){
        if(loading == true){
            return (
                <div className={`popularCarBrands popularCarBrands_white popularTyreBrands`}>
                    <div className='popularCarBrands_title'>
                        <p className='fontSize_16 fontWeight_bold fontStyle_italic fontColor_white'>
                            {t('popular_tyre_brands_in_malaysia')}
                        </p>
                    </div>
                    <ScrollContainer 
                        className='popularCarBrandsList'
                        vertical={false}
                        horizontal={true}
                    >
                        <div className='popularCarBrandsListIniline'>
                            {
                                _.times(4, (key)=>(
                                    <SkeletonTyreBrandItem key={key} />
                                ))
                            }
                        </div>
                    </ScrollContainer>
                </div>
            )
        }
        return (
            <>
                {
                    !_.isEmpty(data) &&
                    <div className={`popularCarBrands popularTyreBrands ${isSingleRow == true && "popularCarBrands_white"}`}>
                        <div className='popularCarBrands_title'>
                            <p className='fontSize_16 fontWeight_bold fontStyle_italic fontColor_white'>
                                {t('popular_tyre_brands_in_malaysia')}
                            </p>
                        </div>
                        <ScrollContainer 
                            className='popularCarBrandsList'
                            vertical={false}
                            horizontal={true}
                        >
                            <div className='popularCarBrandsListIniline'>
                                {
                                    _.reduce(_.take(_.orderBy(data, ['id'], ['desc']), 10), (result, value, key) => {
                                        result.push(
                                            <CustomLink key={key} href={`${pageLink.tyre.tyreMidUrl + value.brand_custom_url}`}>
                                                <div className='popularCarBrandsItem cursorPointer' style={{ width: '9.5rem' }}>
                                                    <div className='popularCarBrandsItem_imageOuter' style={{ width: '9.5rem', height: '5rem' }}>
                                                        <div className="popularCarBrandsItem_image" style={{backgroundImage: `url(${process.env.NEXT_PUBLIC_FS_URL + value.image_path})`}} />
                                                    </div>
                                                    {/* <p className='fontSize_14 popularCarBrandsItem_text'>
                                                        {value.name}
                                                    </p> */}
                                                </div>
                                            </CustomLink>
                                        )
                                        return result
                                    },[])
                                }
                            </div>
                        </ScrollContainer>
                    </div>
                }
            </>
            
        )
    }

    if(loading == true){
        return (
            <div className={`popularCarBrands ${isTyreDetail == true ? "popularTyreBrands" : "popularCarBrands2"}`}>
                <div className={`${isTyreDetail == true ? "popularTyreBrandsDetail_title" : "popularCarBrands_title"}`}>
                    <p className='fontSize_16 fontWeight_bold fontStyle_italic fontColor_white'>
                        {t('popular_tyre_brands_in_malaysia')}
                    </p>
                </div>
                <div className="popularCarBrands2_list" style={{ gridTemplateColumns: 'auto auto auto auto' }}>
                    {
                        _.times(8, (key)=>(
                            <div key={key} className='popularCarBrandsItem cursorPointer' style={{ width: '9.5rem' }}>
                                <SkeletonTyreBrandItem key={key} />
                            </div>
                        ))
                    }
                </div>
                <CustomLink href={`${pageLink.tyre.homepage}`}>
                    <div className="popularCarBrands2_viewmore">
                        <p className="fontSize_14 fontWeight_semiBold fontColor_red">
                            {t('view_more')}
                        </p>
                        <div className="viewMore_icon">
                            <ExpendMore color={colorBlueActiveCode} />
                        </div>
                    </div>
                </CustomLink>
            </div>
        )
    }
    return (
        <>
            {
                !_.isEmpty(data) &&
                <div className={`popularCarBrands ${isTyreDetail == true ? "popularTyreBrands" : "popularCarBrands2"}`}>
                    <div className={`${isTyreDetail == true ? "popularTyreBrandsDetail_title" : "popularCarBrands_title"}`}>
                        <p className='fontSize_16 fontWeight_bold fontStyle_italic fontColor_white'>
                            {t('popular_tyre_brands_in_malaysia')}
                        </p>
                    </div>
                    <div className="popularCarBrands2_list" style={{ gridTemplateColumns: 'auto auto auto auto' }}>
                        {
                            _.reduce(_.take(_.orderBy(data, ['id'], ['desc']), 10), (result, value, key) => {
                                result.push(
                                    <CustomLink key={key} href={`${pageLink.tyre.tyreMidUrl + value.brand_custom_url}`}>
                                        <div className='popularCarBrandsItem cursorPointer' style={{ width: '9.5rem' }}>
                                            <div className='popularCarBrandsItem_imageOuter' style={{ width: '9.5rem', height: '5rem' }}>
                                                <div className="popularCarBrandsItem_image" style={{backgroundImage: `url(${process.env.NEXT_PUBLIC_FS_URL + value.image_path})`}} />
                                            </div>
                                        </div>
                                    </CustomLink>
                                )
                                return result
                            },[])
                        }
                    </div>
                    <CustomLink href={`${pageLink.tyre.homepage}`}>
                        <div className="popularCarBrands2_viewmore cursorPointer">
                            <p className="fontSize_14 fontWeight_semiBold fontColor_red">
                                {t('view_more')}
                            </p>
                            <div className="viewMore_icon">
                                <ExpendMore color={colorRedActiveCode} />
                            </div>
                        </div>
                    </CustomLink>
                </div>
            }
        </>
    )
}

export const RecommendedTyre = (props) => {
    const { data = [], t, loading = false } = props
    if(loading == true){
        return (
            <div className='recommendedCars'>
                <div className='recommendedCars_title'>
                    <p className='fontSize_16 fontWeight_bold fontStyle_italic fontColor_white'>
                        {t('recommended_tyre')}
                    </p>
                </div>
                <ScrollContainer 
                    className='recommendedCarsList'
                    vertical={false}
                    horizontal={true}
                >
                    <div className='recommendedCarsListIniline' style={{ gap: '2rem' }}>
                        {
                            _.times(6, (key)=>(
                                <div key={key} className='recommendedCarsItem cursorPointer' style={{ width: '10.5rem', paddingTop: '6.8rem' }}>
                                    <div className='recommendedCarsItem_imagePosition' style={{ bottom: '6rem', width: '9rem', height: '9rem' }}>
                                        <TyreImage loading={true}/>
                                    </div>
                                    <SkeletonParagraph row={2} isTitle={true} />
                                </div>
                            ))
                        }
                    </div>
                </ScrollContainer>
            </div>
        )
    }
    return (
        <>
            {
                !_.isEmpty(data) &&
                <div className='recommendedCars'>
                    <div className='recommendedCars_title'>
                        <p className='fontSize_16 fontWeight_bold fontStyle_italic fontColor_white'>
                            {t('recommended_tyre')}
                        </p>
                    </div>
                    <ScrollContainer 
                        className='recommendedCarsList'
                        vertical={false}
                        horizontal={true}
                    >
                        <div className='recommendedCarsListIniline' style={{ gap: '2rem' }}>
                            {
                                _.reduce(data, (result, value, key) => {
                                    result.push(
                                        <CustomLink key={key} href={`${pageLink.tyre.tyreMidUrl + value.brand_custom_url + "/" + value.model_custom_url}`}>
                                            <div className='recommendedCarsItem cursorPointer' style={{ width: '10.5rem', paddingTop: '6.8rem' }}>
                                                <div className='recommendedCarsItem_imagePosition' style={{ bottom: '6rem', width: '9rem', height: '9rem' }}>
                                                    <TyreImage 
                                                        imagePath={value.image_path}
                                                    />
                                                </div>
                                                <p className='fontSize_12 fontColor_lightBlue'>
                                                    {value.tyre_brand_name}
                                                </p>
                                                <p className='fontSize_12 fontWeight_semiBold fontColor_blue'>
                                                    {_modelName(value.tyre_brand_name, value.name)}
                                                </p>
                                            </div>
                                        </CustomLink>
                                    )
                                    return result
                                },[])
                            }
                        </div>
                    </ScrollContainer>
                </div>
            }
        </>
    )
}

export const TyreListByBrand = (props) =>{
    const { data = [], t, loading = false } = props
    if(loading == true){
        return (
            <div className='vehicleBrands_hotUpcoming'>
                {
                    _.times(3, (key)=>(
                        <div key={key} className='vehicleBrands_hotUpcoming_item containerPadding'>
                            <div className='vehicleBrands_hotUpcoming_itemBox'>
                                <div className='vehicleBrands_hotUpcoming_itemBox_content'>
                                    {/* <div className='vehicleBrands_hotUpcoming_itemBox_content_top'>
                                        <VehicleModelTypeButton t={t} type={value?.type} />
                                    </div> */}
                                    <div className='vehicleBrands_hotUpcoming_itemBox_content_bottom'>
                                        <div className='fontWeight_semiBold fontColor_blue vehicleBrands_hotUdivcoming_itemBox_content_bottom_title'>
                                            <SkeletonParagraph row={1} isTitle/>
                                        </div>
                                        <div className='fontSize_14 fontWeight_semiBold fontColor_lightBlue vehicleBrands_hotUpcoming_itemBox_content_bottom_row_text'>
                                            <SkeletonParagraph row={1} isTitle/>
                                        </div>
                                    </div>
                                    <div className='fontSize_12 fontColor_lightBlue2 vehicleBrands_hotUpcoming_itemBox_content_bottom_row_text2'>
                                        <SkeletonParagraph row={1}/>
                                    </div>
                                </div>
                                <div className='vehicleBrands_hotUpcoming_itemBox_image' style={{ width: '12rem', height: '12rem' }}>
                                    <div className="vehicleBrands_hotUpcoming_itemBox_imageInner">
                                        <TyreImage 
                                            loading={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        )
    }
    if(_.isEmpty(data)){
        return (
            <EmptyData t={t} />
        )
    }
    return(
        <div className='vehicleBrands_hotUpcoming'>
            {
                _.reduce(data, (result, value, key)=>{
                    result.push(
                        <CustomLink key={key} href={`${pageLink.tyre.tyreMidUrl + value.brand_custom_url + "/" + value.model_custom_url}`} >
                            <div className='vehicleBrands_hotUpcoming_item containerPadding cursorPointer'>
                                <div className='vehicleBrands_hotUpcoming_itemBox'>
                                    <div className='vehicleBrands_hotUpcoming_itemBox_content'>
                                        {/* <div className='vehicleBrands_hotUpcoming_itemBox_content_top'>
                                            <VehicleModelTypeButton t={t} type={value?.type} />
                                        </div> */}
                                        <div className='vehicleBrands_hotUpcoming_itemBox_content_bottom'>
                                            <p className='fontWeight_semiBold fontColor_blue vehicleBrands_hotUpcoming_itemBox_content_bottom_title'>
                                                {value?.brand_name}
                                            </p>
                                            <p className='fontSize_14 fontWeight_semiBold fontColor_lightBlue vehicleBrands_hotUpcoming_itemBox_content_bottom_row_text'>
                                                {_modelName(value.brand_name, value.name)}
                                            </p>
                                        </div>
                                        <p className='fontSize_12 fontColor_lightBlue2 vehicleBrands_hotUpcoming_itemBox_content_bottom_row_text2'>
                                            {`${value.body_type} | ${value.available_inches_string}`}
                                        </p>
                                    </div>
                                    <div className='vehicleBrands_hotUpcoming_itemBox_image' style={{ width: '12rem', height: '12rem' }}>
                                        <div className="vehicleBrands_hotUpcoming_itemBox_imageInner">
                                            <TyreImage 
                                                imagePath={value.image_path}
                                                tagType={value.type}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CustomLink>
                    )
                    return result
                },[])
            }
        </div>
    )
}

export const TyreModelVariant = (props) => {
    const { t, imagePath, loading = false, scrollView = () => {} } = props

    if(loading == true){
        return (
            <div className="tyreModel_tyreHeader">
                <div className="tyreModel_tyreImageOuter">
                    <TyreImage loading={true}/>
                </div>
                <div className="tyreModel_viewTyreSizeButton cursorPointer" onClick={()=>scrollView()}>
                    <p className="fontSize_14 fontWeight_medium fontColor_white">{t('view_all_sizes')}</p>
                </div>
            </div>
        )
    }

    return(
        <div className="tyreModel_tyreHeader">
            <div className="tyreModel_tyreImageOuter">
                {
                    !_.isEmpty(imagePath) ?
                    <img src={`${process.env.NEXT_PUBLIC_FS_URL + imagePath}`} />
                    :
                    <img src={"/assets/images/empty/empty_tyre.png"} />
                }
            </div>
            <div className="tyreModel_viewTyreSizeButton cursorPointer" onClick={()=>scrollView()}>
                <p className="fontSize_14 fontWeight_medium fontColor_white">{t('view_all_sizes')}</p>
            </div>
        </div>
    )
}

export const TyreRatingBox = (props) => {
    const { t, drygrip_braking, wetgrip_braking, longevity, silence_comfort } = props

    let rating = [
        { id: 1, text: 'Drygrip and braking', value: drygrip_braking },
        { id: 2, text: 'Wetgrip and braking', value: wetgrip_braking },
        { id: 3, text: 'Longevity', value: longevity },
        { id: 4, text: 'Silence and Comfort', value: silence_comfort }
    ];
    let ratingLayout = [];
    for(let i = 0; i < rating.length; i++){
        ratingLayout.push(
            <div className="tyreRatingBox_boxRow" key={i}>
                <div className="fontSize_16">{rating[i].text}</div>
                <div className="fontSize_16" style={{ width: '14rem', display: 'flex' }}>
                    {
                        rating[i].value > 0 ?
                        _.times(rating[i].value, (index) => (
                            <IconStar key={index} color={'#FFC327'} />
                        ))
                        : _.times(5, (index) => (
                            <IconStar key={index} color={'#98D4FF'} />
                        ))
                    }
                    {
                        rating[i].value > 0 ?
                        _.times(5 - rating[i].value, (index) => (
                            <IconStar key={index} color={'#98D4FF'} />
                        ))
                        : ""
                    }
                </div>
            </div>
        )
    }

    return(
        <div className="containerPadding">
            <p className="fontSize_18 fontWeight_bold">
                {t('official_rating')}
            </p>
            <div className="tyreRatingBox_boxInner">
                {ratingLayout}
            </div>
        </div>
    )
}

export const TyreDescription = (props) => {
    const { t, description, lineClamp, viewmore, setViewMore = () => {} } = props

    return (
        <div className="containerPadding" style={{ paddingBottom: '1.5rem' }}>
            <p className="fontSize_18 fontWeight_bold" style={{ paddingTop: '1rem' }}>
                {t('tyre_info')}
            </p>
            <div className="fontSize_16 tyreRatingBox_desc" style={{ WebkitLineClamp: `${lineClamp}` }}>
                <div 
                    className="fontSize_16"
                    dangerouslySetInnerHTML={{
                        __html: `${description}`
                    }}
                />
            </div>
            <div onClick={() => { setViewMore() }} className="vehicleModel_SeriesSale_button containerPadding" style={{ display: `${ viewmore ? 'none' : '' }` }}>
                <div className="viewMore cursorPointer">
                    <p className='fontSize_14 fontWeight_semiBold fontColor_blue'>
                        {t('view_more')}
                    </p>
                    <div className="viewMore_icon">
                        <ExpendMore color={colorBlueActiveCode} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export const TyreVariantBox = (props) => {
    const { t, available_inches, data = [], loading = false } = props
    const [isViewMore, setIsViewMore] = useState(false)
    let tyreVariantLimitStart = 1


    if(loading == true){
        return (
            <>
                <div className="tyreVariantBox_inner">
                    {
                        _.times(3,(key)=>(
                            <div className="vehicleModel_SeriesSale_content containerPadding" key={key} style={{ paddingBottom: '1rem' }}>
                                <div className="vehicleModel_SeriesSale_contentItem">
                                    <div className="vehicleModel_SeriesSale_contentItem_header cursorPointer">
                                        <SkeletonParagraph row={1} isTitle={true} />
                                    </div>
                                    <div className="vehicleModel_SeriesSale_contentItem_body">
                                        <div className="vehicleModel_SeriesSale_contentItem_bodyRow">
                                            <div className="tyreVariantBox_row">
                                                <div className="fontSize_16 fontWeight_semiBold">
                                                    <SkeletonParagraph row={1} isTitle={true} />
                                                </div>
                                                <ScrollContainer
                                                    className="tyreVariantBox_vehiclelist"
                                                    vertical={false}
                                                    horizontal={true}
                                                >
                                                    {
                                                        _.times(3,(key)=>(
                                                            <div className="tyreVariantBox_detail" key={key}>
                                                                <div className="tyreVariantBox_vehicleImageOuter">
                                                                    <div className="tyreVariantBox_vehicleImageInner">
                                                                        <Skeleton height={'100%'} width={'100%'} />
                                                                    </div>
                                                                </div>
                                                                <div className='fontSize_12 fontColor_lightBlue'>
                                                                    <SkeletonParagraph row={1} isTitle={true} />
                                                                </div>
                                                                <div className='fontSize_12 fontWeight_semiBold fontColor_blue'>
                                                                    <SkeletonParagraph row={1} isTitle={true} />
                                                                </div>
                                                            </div>
                                                        ))
                                                    }
                                                </ScrollContainer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </>
        )
    }

    if(_.isEmpty(data)){
        return (
            <EmptyData t={t} />
        )
    }

    let organizedData = _.chain(data)
    .groupBy("rim_diameter")
    .map((obj, key) => ({
        'rim_diameter': key,
        'tyre_variant_list': obj
    })).value();

    return (
        <>
            <div className="tyreVariantBox_inner">
                {
                    !_.isEmpty(organizedData) && 
                    _.reduce(organizedData, (result, value, key)=>{
                        if(tyreVariantLimitStart <= 2 || isViewMore == true ){
                            result.push(
                                <div className="vehicleModel_SeriesSale_content containerPadding" key={key} style={{ paddingBottom: '1rem' }}>
                                    <div className="vehicleModel_SeriesSale_contentItem">
                                        <div className="vehicleModel_SeriesSale_contentItem_header cursorPointer">
                                            <p className="fontSize_14 fontColor_blue">Size {value?.rim_diameter}"</p>
                                        </div>
                                        <div className="vehicleModel_SeriesSale_contentItem_body">
                                            <div className="vehicleModel_SeriesSale_contentItem_bodyRow">
                                                {
                                                    _.reduce(value?.tyre_variant_list, (result2, value2, key2)=>{
                                                        if(tyreVariantLimitStart <= 2 || isViewMore == true ){
                                                            tyreVariantLimitStart++
                                                            result2.push(
                                                                <div className="tyreVariantBox_row" key={key2}>
                                                                    <p className="fontSize_16 fontWeight_semiBold">
                                                                        {value2.width}/{value2.aspect_ratio} R{value2.rim_diameter}
                                                                    </p>
                                                                    <ScrollContainer
                                                                        className="tyreVariantBox_vehiclelist"
                                                                        vertical={false}
                                                                        horizontal={true}
                                                                    >
                                                                        {
                                                                            _.reduce(value2.vehicle_list, (result3, value3, key3)=>{
                                                                                result3.push(
                                                                                    <div className="tyreVariantBox_detail" key={key3}>
                                                                                        <div className="tyreVariantBox_vehicleImageOuter">
                                                                                            <div className="tyreVariantBox_vehicleImageInner">
                                                                                                <img className="tyreVariantBox_vehicleImage" src={`${process.env.NEXT_PUBLIC_FS_URL + value3?.image_path}`} />
                                                                                            </div>
                                                                                        </div>
                                                                                        <p className='fontSize_12 fontColor_lightBlue'>
                                                                                            {value3.brand_name}
                                                                                        </p>
                                                                                        <p className='fontSize_12 fontWeight_semiBold fontColor_blue'>
                                                                                            {_modelName(value3.brand_name, value3.name)}
                                                                                        </p>
                                                                                    </div>
                                                                                )
                                                                                return result3
                                                                            },[])
                                                                        }
                                                                    </ScrollContainer>
                                                                </div>
                                                            )
                                                        }
                                                        return result2
                                                    },[])
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        return result
                    },[])
                }
            </div>
            {
                isViewMore == false && _.sumBy(organizedData, (item) => _.get(item, 'tyre_variant_list.length', 0)) >= 3 &&
                <div onClick={()=>{setIsViewMore(true)}} className="vehicleModel_SeriesSale_button containerPadding">
                    <div className="viewMore cursorPointer">
                        <p className='fontSize_14 fontWeight_semiBold fontColor_blue'>
                            {t('view_more')}
                        </p>
                        <div className="viewMore_icon">
                            <ExpendMore color={colorBlueActiveCode} />
                        </div>
                    </div>
                </div>
            }
        </>
    )
}